"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetWorkflowMachineState = void 0;
const react_1 = require("react");
const user_ui_1 = require("@sierralabs/user-ui");
const workflow_1 = require("@sierralabs/workflow");
const useStateNodeByStatus_1 = require("../hooks/useStateNodeByStatus");
const Workflow_context_1 = require("../Workflow.context");
function useGetWorkflowMachineState(task) {
    const { user } = (0, user_ui_1.useUserContext)();
    const { servicePlugins, transitionConditionPlugins, findAsync } = (0, Workflow_context_1.useWorkflowContext)();
    const [workflowMachineState, setWorkflowMachineState] = (0, react_1.useState)({});
    const workflowMachineStateRef = (0, react_1.useRef)(workflowMachineState);
    const machineOptions = (0, react_1.useMemo)(() => {
        const render = (element) => {
            setWorkflowMachineState(Object.assign(Object.assign({}, workflowMachineStateRef.current), { render: element }));
        };
        return {
            guards: transitionConditionPlugins.reduce((guards, plugin) => {
                guards[plugin.type] = (state, params) => {
                    return plugin.guard(state, params, render);
                };
                return guards;
            }, {}),
            services: servicePlugins.reduce((services, plugin) => {
                services[plugin.src] = (state, params) => {
                    return plugin.service(state, params, render);
                };
                return services;
            }, {})
        };
    }, [servicePlugins, transitionConditionPlugins]);
    const canTransition = (0, react_1.useCallback)((event, context) => __awaiter(this, void 0, void 0, function* () {
        const { machine, stateNode } = workflowMachineStateRef.current;
        try {
            return yield (machine === null || machine === void 0 ? void 0 : machine.canTransition({ context, path: (stateNode === null || stateNode === void 0 ? void 0 : stateNode.path) || '' }, event.name));
        }
        catch (error) {
            console.error('[canTransition]', error);
        }
    }), []);
    const handleTransition = (0, react_1.useCallback)((event, context) => __awaiter(this, void 0, void 0, function* () {
        const { machine, stateNode } = workflowMachineStateRef.current;
        try {
            return yield (machine === null || machine === void 0 ? void 0 : machine.transition({ context, path: (stateNode === null || stateNode === void 0 ? void 0 : stateNode.path) || '' }, event === null || event === void 0 ? void 0 : event.name));
        }
        catch (error) {
            console.error('[handleTransition]', error);
        }
    }), []);
    const runMachine = (0, react_1.useCallback)((task) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const workflow = (_a = (yield findAsync(task))) === null || _a === void 0 ? void 0 : _a.workflow;
        if (!workflow) {
            return {};
        }
        const machine = new workflow_1.WorkflowMachine(workflow, machineOptions);
        workflowMachineStateRef.current.workflow = workflow;
        workflowMachineStateRef.current.machine = machine;
        const stateNode = (0, useStateNodeByStatus_1.getStateNodeByStatus)(task.status, workflow);
        if (stateNode) {
            workflowMachineStateRef.current.stateNode = stateNode;
        }
        else {
            try {
                const state = yield machine.start({ task, user });
                workflowMachineStateRef.current.stateNode = workflow.getState(state.path);
            }
            catch (error) {
                console.error(error);
            }
        }
        return { workflow, machine, stateNode };
    }), [machineOptions, user, findAsync]);
    // run the machine when task changes
    (0, react_1.useEffect)(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            if (task) {
                const workflowMachineState = yield runMachine(task);
                setWorkflowMachineState(workflowMachineState);
            }
        }))();
    }, [task, runMachine]);
    return Object.assign(Object.assign({}, workflowMachineState), { runMachine,
        canTransition,
        handleTransition });
}
exports.useGetWorkflowMachineState = useGetWorkflowMachineState;
//# sourceMappingURL=Task.machine.js.map